/**
 * UI Quantity helpers - for converting between server quantities and UI display
 */

export type UIQuant = 'XPC' | 'GRM' | 'KGM'

/**
 * Convert server amount to UI display amount
 */
export const convertToUIQuant = (amount: number, uiQuant: UIQuant): number => {
  switch (uiQuant) {
  case 'KGM':
    return amount / 1000
  default:
    return amount
  }
}

/**
 * Convert UI display amount to server amount
 */
export const convertToCartQuant = (amount: number, uiQuant: UIQuant): number => {
  switch (uiQuant) {
  case 'KGM':
    return amount * 1000
  default:
    return amount
  }
}

/**
 * Normalize amount with step and convert to server quantity
 */
export const normalizeAmountWithUIQuant = (
  amount: number,
  step: number,
  uiQuant: UIQuant
): number => {
  if (amount === step) {
    return convertToCartQuant(amount, uiQuant)
  }
  
  const roundedAmount = Math.floor(amount / step) * step
  const normalizedAmount = roundedAmount === 0 && amount !== 0 ? step : roundedAmount
  return convertToCartQuant(normalizedAmount, uiQuant)
}

/**
 * Get unit postfix based on uiQuant
 */
export const getUIQuantPostfix = (uiQuant: UIQuant, t: (key: string) => string): string => {
  switch (uiQuant) {
  case 'KGM':
    return t('weight.kg')
  case 'GRM':
    return t('weight.gr')
  default:
    return t('weight.pc')
  }
}